interface NestedLayoutProps {
  children: React.ReactNode;
  className?: string | "";
  style?: React.CSSProperties;
}

export const NestedLayout = ({
  children,
  className,
  style,
}: NestedLayoutProps) => {
  return (
    <div
      className={`px-5 sm:px-5 lg:px-16 xl:px-28 2xl:px-56 ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};
